import { render, staticRenderFns } from "./ModalTerms.vue?vue&type=template&id=c65e798c&scoped=true"
import script from "./ModalTerms.vue?vue&type=script&lang=js"
export * from "./ModalTerms.vue?vue&type=script&lang=js"
import style0 from "./ModalTerms.vue?vue&type=style&index=0&id=c65e798c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65e798c",
  null
  
)

export default component.exports